export const FISCAL_YEAR_API = (communityId: number | string) =>
  `v1/communities/${communityId}/fiscal-years`;